import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { FaTools } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function SevicesTwoCard({ thumbnail, slug, heading, text }) {
    return (
        <div className="col-md-6 col-xl-4 col-12">
            <div className="single-service-card">
                <div
                    className="card-thumb bg-cover"
                    style={{
                        backgroundImage: `url(${thumbnail})`,
                    }}
                />
                <div className="content">
                    <div className="case-cat">
                        <Link to={`/servicii/${slug}`}><FaTools /></Link>
                    </div>
                    <h3>
                        <Link to={`/servicii/${slug}`}>{heading}</Link>
                    </h3>
                    <p>{text}</p>
                    <Link to={`/servicii/${slug}`} className="read-btn">
                        Detalii <BsArrowRight />
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default SevicesTwoCard;
